export enum NotifyOptions {
  // ONLY_AFFECTED_SCHEDULES = 'onlyAffectedSchedules',
  ALL = 'all',
  NO_NOTIFY = 'doNotNotify',
}